<form [formGroup]="userForm" (ngSubmit)="onSubmit($event)" id="userForm" novalidate> 
  <div class="mb-3 px-4">
    <label for="name" class="form-label">Name</label>
    <input 
      type="text" 
      id="name" 
      class="form-control"
      placeholder="Enter your name"
      formControlName="name"
      required>
  </div>               

  <div class="mb-3 px-4">
    <label for="email" class="form-label">Email</label>
    <input 
      type="email" 
      id="email" 
      class="form-control"
      placeholder="Enter your email"
      formControlName="Email"
      required>
  </div>

  <div class="mb-3 px-4">
    <label for="isActive" class="form-label">IsActive</label>
    <label class="px-4">
      <input type="radio" formControlName="IsActive" name="IsActive" [value]=true required> Yes
    </label>
    <label>
      <input type="radio" formControlName="IsActive" name="IsActive" [value]=false required> No
    </label>
  </div>     

  <div class="d-flex justify-content-center mt-3">
    <button class="btn btn-add" type="submit">
      Add
    </button>
  </div>
</form>